import React from "react"
import ReactMarkdown from "react-markdown"
import { graphql } from "gatsby"
import Layout from "../components/_App/layout"
import Seo from "../components/_App/seo"
import Navbar from "../components/_App/NavbarSecondDepartment"
import PageBanner from "../components/Common/PageBanner"
import Footer from "../components/_App/Footer"
import { useI18next } from 'gatsby-plugin-react-i18next';

const LaboratoriesDetailsPage = ({ data }) => {
  const { title,
    titleAr,
    Details, DetailsAr, image
  } = data.Laboratories
  const { language } = useI18next();

  return (
    <Layout>
      <Navbar />

      <PageBanner pageTitle={language === "ar" ? titleAr : title} />

      <div className="about-area ptb-80">
        <div className="container">
          <div className="row align-items-start-100">
            <div className="col-lg-7 col-md-12">
              <div className="about-content">
                <div className="section-title">
                  <h2>{language === "ar" ? titleAr : title}</h2>

                  <div className="bar"></div>
                </div>
                <ReactMarkdown>
                  {language === "ar" ? DetailsAr.data.DetailsAr : Details.data.Details}
                </ReactMarkdown>

              </div>
            </div>
            <div className="col-lg-5 col-md-12">
              <div className="about-image d-flex justify-content-end">
                <img
                  style={{ maxHeight: "320px" }}
                  className="rounded"
                  src={`${'https://cmstecheng.nustwebsite.com'}${image.url}`}
                  alt={"Laboratories"} />
              </div>
            </div>
          </div>
        </div>
      </div>
      

      <Footer />
    </Layout>
  )
}

export const query = graphql`
  query GetSingleLaboratories($slug: String, $language: String!) {
    Laboratories: strapiLaboratories(slug: { eq: $slug }) {
      title
      titleAr
      Details {
        data {
          Details
        }
      }
      DetailsAr {
        data {
          DetailsAr
        }
      }
      image{
        url
      }

    }
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => <Seo title="laboratories" />

export default LaboratoriesDetailsPage
